import styled from 'styled-components';

export const RatingsContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const RatingScore = styled.div`
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: -4.8px;
  color: #000;

  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

export const StarRatingColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
`;

export const RatingsCount = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #5e5e5e;

  @media (prefers-color-scheme: dark) {
    color: #cecece;
  }
`;
